import React, { useEffect } from 'react'
import { batch, useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEffectOnce } from '@chilecompra/react-kit'
import { Spinner } from '@chilecompra/react-kit/components'
import { REACT_APP_UNIQUE_PASS_SEED } from '../../config/settings/environment'
import routes from '../../config/settings/routes'
import { useCsrfToken } from '../../modules/hooks/security'
import { onGetTokenThunk } from './UniquePassAuth.actions'
import { onRegisterBy } from '../RegisterWizard/RegisterWizard.actions'
import { Root } from './UniquePassAuth.styles'

/**
 * The UniquePassAuth's container.
 */
const UniquePassAuth = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { error, isRecoveryAdmin, loading } = useSelector(state => state.uniquePassAuth)
  const csrfToken = useCsrfToken(REACT_APP_UNIQUE_PASS_SEED)
  const hash = new URLSearchParams(location.hash)
  const code = hash.get('code')

  useEffectOnce(() => {
    batch(() => {
      dispatch(onGetTokenThunk({ csrfToken, code }))
      dispatch(onRegisterBy('by-unique-pass'))
    })
  })

  useEffect(() => {
    if (loading) {
      return
    }

    if (error) {
      return navigate(routes.registerWizard, { replace: true, state: { defaultStepID: 'business-search' } })
    }

    if (isRecoveryAdmin) {
      return navigate(routes.registerWizard, { replace: true, state: { defaultStepID: 'recovery-company' } })
    }

    navigate(routes.registerWizard, { replace: true, state: { defaultStepID: 'personal-info' } })
  }, [isRecoveryAdmin, loading])

  if (loading) {
    return (
      <Root>
        <Spinner />
      </Root>
    )
  }

  return null
}

export default UniquePassAuth
